import { INSPECTION_STORE_NAME } from '@/constants/constants';
import { Inspection } from '@/types/inspection-types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearClientStores } from '@/stores/clearClientStores';

export type Pagination = {
  totalInspections: number;
  totalPages: number;
  currentPage: number;
  resourcesPerPage: number;
  sort: string;
};
interface InspectionState {
  isStoreHydrated: boolean;
  inspections: Inspection[];
  isLoading: boolean;
  updatedAt: Date | null;
  inspectionPagination: Pagination;
  selectedInspection: string | null;
  showDeletePopup: boolean;
}

type Actions = {
  updateInspectionPagination: (update: Partial<Pagination>) => void;
  fetchInspections: (cellId: string, signal: AbortSignal) => Promise<void>;
  updateInspectionList: (inspectionList: Inspection[]) => void;
  updateSelectedInspection: (inspectionId: string | null) => void;
  setIsStoreHydrated: (isHydrated: boolean) => void;
  resetStore: () => void;
  setShowDeletePopup: (showPopup: boolean) => void;
  toggleShowDeletePopup: () => void;
  // deleteClickHandler: () => Promise<void>;
  // resetPaginationState: () => void;
};

const baseUrl = process.env.NEXT_PUBLIC_MARK_2_API;

export const useInspectionStore = create<InspectionState & Actions>()(
  persist(
    (set, get) => ({
      isStoreHydrated: false,
      inspections: [],
      isLoading: false,
      updatedAt: null,
      inspectionPagination: {
        totalInspections: 0,
        totalPages: 0,
        currentPage: 1,
        resourcesPerPage: 25,
        sort: 'desc'
      },
      selectedInspection: null,
      showDeletePopup: false,
      updateSelectedInspection: (inspectionId: string | null) => {
        set((state) => ({
          selectedInspection: (state.selectedInspection = inspectionId)
        }));
      },
      updateInspectionPagination: (update: Partial<Pagination>) => {
        set((state) => ({
          inspectionPagination: { ...state.inspectionPagination, ...update }
        }));
        // const pagination = get().inspectionPagination;
        // console.log('Pagination after update: ', pagination);
      },
      fetchInspections: async (cellId: string, signal: AbortSignal) => {
        set((state) => ({ isLoading: (state.isLoading = true) }));
        const sort = get().inspectionPagination.sort;
        const page = get().inspectionPagination.currentPage;
        const limit = get().inspectionPagination.resourcesPerPage;

        // console.log('cellId: ', cellId);
        try {
          const res = await fetch(
            `${baseUrl}api/v2/inspection/flex?sort=${sort}&page=${page}&limit=${limit}&cell_id=${cellId}`,
            {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              signal: signal
            }
          );

          if (res.status === 200) {
            const parsedInspections = await res.json();

            console.log('parsed res from store: ', parsedInspections);
            const pagination = {
              totalInspections: parsedInspections.data.totalResources,
              totalPages: parsedInspections.data.totalPages,
              currentPage: parsedInspections.data.currentPage
            };
            //   setInspectionList({ ...parsedInspections, status: res.status });
            set((state) => ({
              inspections: (state.inspections =
                parsedInspections.data.resources)
            }));
            set((state) => ({
              inspectionPagination: {
                ...state.inspectionPagination,
                ...pagination
              }
            }));
            set((state) => ({ updatedAt: (state.updatedAt = new Date()) }));
            set((state) => ({ isLoading: (state.isLoading = false) }));
          } else if (res.status === 401) {
            if (window !== undefined) {
              clearClientStores();
              window.location.assign('/auth/logout');
            }
          } else {
            set((state) => ({ isLoading: (state.isLoading = false) }));
            // set((state) => ({ updatedAt: (state.updatedAt = new Date()) }));
          }
        } catch (error) {
          set((state) => ({ isLoading: (state.isLoading = false) }));
        }
      },
      updateInspectionList: (inspectionList: Inspection[]) => {
        set((state) => ({
          inspections: (state.inspections = inspectionList)
        }));
      },
      setIsStoreHydrated: (isHydrated: boolean) => {
        set((state) => ({
          isStoreHydrated: (state.isStoreHydrated = isHydrated)
        }));
      },
      resetStore: () => {
        set((state) => ({
          // isStoreHydrated: false,
          inspections: [],
          isLoading: false,
          updatedAt: null,
          inspectionPagination: {
            totalInspections: 0,
            totalPages: 0,
            currentPage: 1,
            resourcesPerPage: 25,
            sort: 'desc'
          }
        }));
      },
      setShowDeletePopup: (showPopup: boolean) => {
        set((state) => ({
          showDeletePopup: (state.showDeletePopup = showPopup)
        }));
      },
      toggleShowDeletePopup: () => {
        set((state) => ({
          showDeletePopup: (state.showDeletePopup = !state.showDeletePopup)
        }));
      }
      // deleteClickHandler: async () => {}
      // resetPaginationState: () => {
      //   console.log('Reset pagination state');
      // }
    }),
    {
      name: INSPECTION_STORE_NAME,
      onRehydrateStorage: () => (state) => {
        state?.setIsStoreHydrated(true);
      }
    }
  )
);
